import { render, staticRenderFns } from "./Frame13.vue?vue&type=template&id=1bde45f0&scoped=true"
import script from "./Frame13.vue?vue&type=script&lang=js"
export * from "./Frame13.vue?vue&type=script&lang=js"
import style0 from "./Frame13.vue?vue&type=style&index=0&id=1bde45f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde45f0",
  null
  
)

export default component.exports